import styled, { css } from 'styled-components';

export const Button = styled.button<{ $showBigger: boolean; $onVideo?: boolean }>(
  ({ theme, $showBigger, $onVideo }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: ${theme.sz.s1};
    width: ${$showBigger ? theme.sz.s16 : theme.sz.s12};
    height: ${$showBigger ? theme.sz.s16 : theme.sz.s12};
    color: ${theme.co.secondary20};
    background: ${$onVideo ? theme.co.neutral99 : 'transparent'};
    cursor: pointer;
    font-size: ${$showBigger ? theme.DEPRECATED_ty.largest : theme.DEPRECATED_ty.larger};
    border: 2px solid ${theme.co.secondary80};
    box-shadow: 0 4px 0 ${theme.co.secondary80};
    border-radius: ${theme.sz.s4};
    &:active,
    &:active:visited,
    &:hover,
    &:hover:visited {
      box-shadow: 0 6px 0 ${theme.co.secondary80};
      transform: translateY(-2px);
    }
    &:disabled {
      background-color: ${theme.co.secondary80};
      cursor: not-allowed;
    }

    ${
      $onVideo &&
      css`
        @media (max-width: ${theme.sz.md}) {
          width: ${$showBigger ? theme.sz.s12 : theme.sz.s10};
          height: ${$showBigger ? theme.sz.s12 : theme.sz.s10};
          font-size: ${$showBigger ? theme.DEPRECATED_ty.larger : theme.DEPRECATED_ty.large};
          border-radius: ${theme.sz.s3};
        }
      `
    }
  `,
);
